/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionPricingQuery = gql`
  query GetSouscriptionPricingQuery {
    getSouscriptionPricing_souscription_pricing {
      offer {
 effectDate  
packs {
 code  
customerId  
granteeId  
pricings {
 isSelected  
isPreSelected  
isRecommended  
moduleLabel  
moduleCode  
supplementaryCover  
prices {
 price  
defaultPrice  
} 
} 
} 
code  
}
      relaisSelfcareIsNecessary 
      selfcareIsActive 
    }
  }
`;

export default GetSouscriptionPricingQuery;
